import { flushAllDirty, isAnyUnsaved } from 'hooks/data-saving/saveStatusStore';
import { useEffect } from 'react';

/**
 * Last line of defence for closing the tab or reloading. In-app navigation is already safe — every
 * editor commits from its unmount cleanup — but a tab close kills anything still in local state AND
 * any write still on the wire: Firestore offline persistence is not enabled, so unacknowledged writes
 * are held in memory only and die with the page.
 *
 * Flushing BEFORE prompting is deliberate. If the user then cancels, the writes are already on their
 * way and the work is saved anyway; if they leave, they at least did so knowingly.
 *
 * Mounted once, app-wide. Inert until some editor registers unsaved work.
 */
export default function GlobalUnsavedGuard() {
  useEffect(() => {
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!isAnyUnsaved()) return;
      flushAllDirty();
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);

  return null;
}
